<template>
  <v-row>
    <v-col cols="6">
      <!-- 通貨 -->
      <SelectCurrency v-model="inputedValue" :clearable="true" />
    </v-col>
    <v-col cols="6"> </v-col>
  </v-row>
</template>

<script>
import { SelectCurrency } from '@/components/items/Selectboxes'

export default {
  components: {
    SelectCurrency
  },
  props: {
    value: {}
  },
  data: () => ({
    items: []
  }),
  created() {
    //
  },
  computed: {
    inputedValue: {
      get() {
        return this.value
      },
      set(newValue) {
        this.$emit('input', newValue)
      }
    }
  }
}
</script>
<style scoped lang="scss"></style>
